export default {
      id: "portfolio-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#portfolio",
      toString: function () {
        return this.url;
      }
    }